import { GroupInlined } from '../group/group.model';
import {
    IRestrictedAccountObjectArgs,
    RestrictedAccountObject
} from '../restricted-account-object/restricted-account-object.model';
import { VasFormConfigDto } from './vas-form-config.dto';

export interface IFormArgs extends IRestrictedAccountObjectArgs {
    title?: string;
    description?: string;
    groups?: Array<string> | Array<GroupInlined>;
    jobType?: string;
    config?: string | VasFormConfigDto;
    geoLocationEnabled?: boolean;
}

const defaults = {
    title: '',
    description: '',
    groups: [],
    jobType: '',
    config: '',
    geoLocationEnabled: false
} as IFormArgs;

abstract class AbstractForm extends RestrictedAccountObject {
    title: string;
    description: string;
    groups: Array<string> | Array<GroupInlined>;
    jobType: string;
    config: VasFormConfigDto;
    geoLocationEnabled: boolean;

    constructor(data?: IFormArgs) {
        super({...defaults, ...data} as any);
    }
}

export class Form extends AbstractForm {
    groups: Array<string>;

    constructor(data?: IFormArgs) {
        super({...defaults, ...data} as any);
        this.setConfig(data ? data.config : '');
    }

    setConfig(config: string | VasFormConfigDto): void {

        if (typeof config !== 'string') {
            this.config = config;
            return;
        }

        const fallBack = {
            emailRecipients: {
                job: [],
                static: []
            }
        };

        if (!config) {
            this.config = fallBack;
            return;
        }
        try {
            this.config = JSON.parse(config);
        } catch (e) {
            this.config = fallBack;
        }
    }
}

export class FormInlined extends AbstractForm {
    groups: Array<GroupInlined>;

    constructor(data?: IFormArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/form/form.model.ts